/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebfieldcountry3Inputs */

const en_placewebfieldcountry3 = /** @type {(inputs: Placewebfieldcountry3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country`)
};

const de_placewebfieldcountry3 = /** @type {(inputs: Placewebfieldcountry3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land`)
};

/**
* | output |
* | --- |
* | "Country" |
*
* @param {Placewebfieldcountry3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebfieldcountry3 = /** @type {((inputs?: Placewebfieldcountry3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebfieldcountry3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebfieldcountry3(inputs)
	return de_placewebfieldcountry3(inputs)
});
export { placewebfieldcountry3 as "placeWebFieldCountry" }